require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/core-js/modules/es6.array.species.js
// module id = Umeq
// module chunks = 0